export default "__VITE_ASSET__CtvNIqSi__"